export default __webpack_public_path__ + "static/media/iac.8375e8d2.jpg";